export const DEFAULT_BOARD_BACKGROUND_COLOR = '#f0f1f2';
